import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { H5 } from 'foundations-components/transitional/components/H5';
import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { DetailViewsZeroStateCHIRP } from './DetailViewsZeroStateCHIRP';
import { useGetVisitsForDocumentAndViewerIdQuery } from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsAnalyticsService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadableDetailViewsCardContentsCHIRP = Loadable({
  loader: () => import( /* webpackChunkName: "document-visits-detail-card" */'./DetailViewsCardContentsCHIRP'),
  LoadingComponent: ({
    pastDelay
  }) => pastDelay ? /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered"
  }) : null,
  ErrorComponent: ({
    retry
  }) => /*#__PURE__*/_jsx(Alert, {
    use: "inline",
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.detail.views.error.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "summary.detail.views.error.description_jsx",
      options: {
        onClick: retry
      },
      elements: {
        Link
      }
    })
  })
});
export const DetailViewsCardCHIRP = ({
  documentId,
  selectedVisitor
}) => {
  var _data$visits;
  const {
    data,
    loading
  } = useGetVisitsForDocumentAndViewerIdQuery({
    variables: {
      documentId,
      viewerId: selectedVisitor.viewerId
    }
  });
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 200,
        layout: "centered"
      })
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    paddingInlineStart: "400",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.detail.views.title"
      })
    }), (data === null || data === void 0 || (_data$visits = data.visits) === null || _data$visits === void 0 ? void 0 : _data$visits.length) === 0 ? /*#__PURE__*/_jsx(DetailViewsZeroStateCHIRP, {
      contact: selectedVisitor.contact
    }) : /*#__PURE__*/_jsx(LoadableDetailViewsCardContentsCHIRP, {
      documentId: documentId,
      selectedVisitor: selectedVisitor
    })]
  });
};